import { render, staticRenderFns } from "./AutomationCampaignHrAwareness.vue?vue&type=template&id=cf80fd20&scoped=true"
import script from "./AutomationCampaignHrAwareness.vue?vue&type=script&lang=js"
export * from "./AutomationCampaignHrAwareness.vue?vue&type=script&lang=js"
import style0 from "./AutomationCampaignHrAwareness.vue?vue&type=style&index=0&id=cf80fd20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf80fd20",
  null
  
)

export default component.exports